import api from '../api';

export const path = '/car/get';

export const getCarTypeRequest = () => api.get(`${path}/type`);

export const getCarMarkRequest = (type) =>
    api.get(`${path}/mark`, { params: { type } });

export const getCarModelRequest = (mark) =>
    api.get(`${path}/model`, { params: { mark } });

export const getCarGenerationRequest = (params) =>
    api.get(`${path}/generation`, { params });

export const getCarBodyTypeRequest = (params) =>
    api.get(`${path}/bodyType`, { params });

export const getCarModificationRequest = (params) =>
    api.get(`${path}/modification`, { params });

export const getCarCharacteristicRequest = (params) =>
    api.get(`${path}/characteristic`, {
        params,
    });

export const getCarTechDataRequest = (params) =>
    api.get(`${path}/techData`, {
        params: { params },
    });
